export default __webpack_public_path__ + "static/blog_logo-6879d5773cbdbe4b219b87d7c7a64b82.svg";